import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import CineMovie from './components/CineMovie';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const HomePage = () => (
    <>
      <main className="pt-16">
        <Home />
        <About />
        <Projects />
        <Contact />
      </main>
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p>&copy; {new Date().getFullYear()} Imran Melikov. All rights reserved.</p>
        </div>
      </footer>
    </>
  );

  const AppContent = () => {
    const location = useLocation();
    const showNavbar = location.pathname === '/';

    return (
      <div className="relative">
        {showNavbar && (
          <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-center h-16">
                <div className="flex-shrink-0">
                  <span className="text-2xl font-bold text-primary">IM</span>
                </div>

                <div className="hidden md:flex space-x-8">
                  {navItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => scrollToSection(item.id)}
                      className="text-gray-700 hover:text-primary transition-all duration-200 transform hover:scale-105"
                    >
                      {item.label}
                    </button>
                  ))}
                </div>

                <div className="md:hidden">
                  <button
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="text-gray-700 hover:text-primary transition-colors duration-200"
                  >
                    {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                  </button>
                </div>
              </div>
            </div>

            {isMenuOpen && (
              <div className="md:hidden">
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white">
                  {navItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => scrollToSection(item.id)}
                      className="block w-full text-left px-3 py-2 text-gray-700 hover:text-primary hover:bg-gray-50 transition-all duration-200"
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </nav>
        )}

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cinemovie" element={<CineMovie />} />
        </Routes>
      </div>
    );
  };

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
